import type { Config, Environment } from './environment';
import { getEnvironment } from './environment';
import { getValidatedConfig } from './validation';

// Get validated config for the current environment
const currentConfig = getValidatedConfig();

// Export config as individual variables and as a complete object
export const { apiUrl, apiServerUrl, auth0, socketUrl, redisUrl, stripeKey, cdnUrl } =
  currentConfig;

export const environment = getEnvironment();

// Export the entire config object
export default currentConfig;

// Export types and functions
export type { Config, Environment };
export { getEnvironment };

// Export React Query options
export * from './queryOptions';
